import {
  LCircleMarker,
  LControl,
  LControlLayers,
  LControlScale,
  LControlZoom,
  LGeoJson,
  LLayerGroup,
  LMap,
  LTileLayer,
  LWMSTileLayer
} from "vue2-leaflet";
import L from "leaflet";
import router from "@/router";

export default {
  data: () => ({
    name: "map_component",
    map: null,
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    nameVar: "",
    bounds: L.latLngBounds([
      [60, 100],
      [-60, -100]
    ]),
    countriesVisible: true,
    countryView: false,
    countryCode: "",
    countryName: "",
    maxBounds: L.latLngBounds([
      [80, 200],
      [-80, -200]
    ]),
    geojson: [],
    isoLayer: true,
    tileProviders: [
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      },
      {
        name: "OpenTopoMap",
        visible: false,
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
      },
      {
        name: "Humanitarian OSM",
        visible: false,
        url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>)'
      },
      {
        name: "CartoDB Positron",
        visible: false,
        url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
      }
    ]
  }),
  components: {
    LMap,
    LTileLayer,
    LControlLayers,
    LControlScale,
    "l-wms-tile-layer": LWMSTileLayer,
    LGeoJson,
    LCircleMarker,
    LControl,
    LControlZoom,
    LLayerGroup
  },

  props: [
    "sidebarVisible",
    "layerName",
    "layerStyle",
    "selectedCountry",
    "layerTransparency",
    "countries",
    "showFacilities",
    "facilityType"
  ],
  watch: {
    layerName() {
      if (this.layerName.includes("iso")) {
        this.isoLayer = true;
        this.nameVar = "Accessibility [National]";
      } else if (this.layerName.includes("adm1")) {
        this.isoLayer = false;
        this.nameVar = "Accessibility [admin 1]";
      } else {
        this.isoLayer = false;
        this.nameVar = "Accessibility [Hexagon 8]";
      }
    },
    sidebarVisible() {
      if (!this.sidebarVisible) {
        this.resetMap();
      }
    },
    selectedCountry() {
      if (this.selectedCountry) {
        this.zoomToFeatureByName();

        //this.countryName = this.selectedCountry.properties.country_name;
      }
    }
  },
  methods: {
    passCountryName() {
      this.$emit("getCountryName", this.countryName);
    },
    passCountryCode() {
      this.$emit("getCountryCode", this.countryCode);
    },
    resetMap() {
      //this.$refs.map.mapObject.setView([10, 30], 3);
      //this.$refs.map.mapObject.fitBounds(this.bounds);
      this.bounds = L.latLngBounds([
        [60, 100],
        [-60, -100]
      ]);
      this.countriesVisible = true;
      this.countryView = false;
      window.dispatchEvent(new Event("resize"));
    },
    zoomToFeature(feature) {
      let urlIdentify =
        "/countries/" + feature.properties.iso_code.toLowerCase();

      router.push(urlIdentify);
      /*let bbox = [feature.properties.x_min, feature.properties.x_max,
                feature.properties.y_min, feature.properties.y_max]
            let extent = [[bbox[3], bbox[1]],
                [bbox[2], bbox[0]]]
            this.countriesVisible = false;
            this.countryView = true;
            this.countryCode = feature.properties.iso_code.toLowerCase();
            this.countryName = feature.properties.country_name;
            this.passCountryCode();
            this.passCountryName();
            this.standardView();

            this.bounds = L.latLngBounds(extent)

            this.$emit("sidebar", true);
            window.dispatchEvent(new Event('resize'))*/
    },
    async zoomToFeatureByName() {
      let feature = this.selectedCountry;

      let bbox = [
        feature.properties.x_min,
        feature.properties.x_max,
        feature.properties.y_min,
        feature.properties.y_max
      ];
      let extent = [
        [bbox[3], bbox[1]],
        [bbox[2], bbox[0]]
      ];
      this.countriesVisible = false;
      this.countryView = true;
      this.countryCode = feature.properties.iso_code.toLowerCase();
      this.countryName = feature.properties.country_name;
      this.passCountryCode();
      this.passCountryName();
      this.standardView();
      await new Promise(r => setTimeout(r, 200));
      this.bounds = L.latLngBounds(extent);

      this.$emit("sidebar", true);
      window.dispatchEvent(new Event("resize"));
    },
    standardView() {
      this.$emit("getLayerName", this.countryCode + "_both_iso_layer");
      this.$emit("getLayerStyle", "iso_value_viridis");
    }
  },
  computed: {
    health_geoserver() {
      return {
        baseUrl: process.env.VUE_APP_GEOSERVER_URL,
        layers: [
          {
            name: this.nameVar,
            key: this.layerName + Math.random(1),
            visible: true,
            format: "image/png",
            layers: "health-acc:" + this.layerName,
            transparent: true,
            options: { tiled: true },
            opacity: parseFloat(this.layerTransparency) / 100,
            styles: "health-acc:" + this.layerStyle,
            attribution:
              '<a href="https://openrouteservice.org/services/"> openrouteservice</a>, <a href="https://www.worldpop.org/">WorldPop</a>,<a href="https://www.geoboundaries.org/"> geoboundaries</a>',
            type: "overlay",
            wmsZIndex: 98
          },
          {
            name: "Healthcare Facilities",
            key: this.facilityType + Math.random(1),
            format: "image/png",
            layers:
              "health-acc:" +
              this.selectedCountry.properties.iso_code.toLowerCase() +
              "_source_pts_" +
              this.facilityType,
            transparent: true,
            options: { tiled: true },
            styles: "health-acc:src_pts_" + this.facilityType,
            attribution: "",
            visible: this.showFacilities,
            type: "overlay2",
            wmsZIndex: 100
          }
        ]
      };
    },
    options() {
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    styleFunction() {
      return () => {
        return {
          color: "#c61414",
          fillColor: "#c61414",
          weight: 2,
          opacity: 0.25,
          fillOpacity: 0.25
        };
      };
    },

    onEachFeatureFunction() {
      return (feature, layer) => {
        layer.bindTooltip(
          "<div><b>" + feature.properties.country_name + "</b></div>",
          { permanent: false, sticky: true }
        );

        function highlightFeature(e) {
          let layer1 = e.target;

          layer1.setStyle({
            weight: 5,
            color: "#ffffff",
            dashArray: "",
            fillOpacity: 0.7
          });
        }

        function resetHighlight(e) {
          let layer1 = e.target;

          layer1.setStyle({
            color: "#c61414",
            fillColor: "#c61414",
            weight: 2,
            opacity: 0.25,
            fillOpacity: 0.25
          });
        }

        layer.on({
          mouseover: highlightFeature,
          mouseout: resetHighlight
        });
      };
    }
  }
};
